export default __webpack_public_path__ + "static/media/hamburger.dc8d7043.svg";